/**
 * HeatProfilePage - Heat Profile Page with Modern Layout
 * 
 * This page wraps the existing HeatProfile component with the modern UI layout,
 * matching the DPR page style. All existing functionality (CRUD, PDF generation,
 * signatures, email sharing, search, pagination) is preserved.
 * 
 * Access at: /heat-profile (opens in new tab from Technical page)
 * Layout: Uses ModernLayout which provides consistent left/right margins and sidebar
 */

import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Flame, FileText, Wrench } from 'lucide-react';
import HeatProfile from '../../components/HeatProfile';
import './HeatProfilePage.css';

const TECHNICAL_TAB_ITEMS = [
    { id: 'heat-profile', label: 'Heat Profile', path: '/heat-profile', icon: <Flame size={18} /> },
    { id: 'test-repository', label: 'Test Repository', path: '/TechnicalPage', icon: <FileText size={18} /> },
    { id: 'dcal-generator', label: 'DCAL Generator', path: '/DCALGenerator', icon: <Wrench size={18} /> },
];

const HeatProfilePage = () => {
    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;



    const handleTabClick = (path) => {
        if (path !== currentPath) {
            history.push(path);
        }
    };

    return (
        <div className="heat-profile-page">
            {/* Tabs: Heat Profile, Test Repository, DCAL Generator */}
            <div className="heat-profile-tabs-container">
                <div className="heat-profile-tabs">
                    {TECHNICAL_TAB_ITEMS.map((item) => (
                        <div
                            key={item.id}
                            className={`heat-profile-tab-item ${currentPath === item.path ? 'active' : ''}`}
                            onClick={() => handleTabClick(item.path)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleTabClick(item.path);
                                }
                            }}
                            role="tab"
                            tabIndex={0}
                            aria-selected={currentPath === item.path}
                        >
                            {item.icon}
                            {item.label}
                        </div>
                    ))}
                </div>
            </div>


            {/* Heat Profile Content - renders the existing HeatProfile component */}
            <div className="heat-profile-content-wrapper">
                <HeatProfile />
            </div>
        </div>
    );
};

export default HeatProfilePage;
